import { DialogTitle, DialogContent, DialogActions, DialogContentText, Button } from '@mui/material';
import { colors } from 'Constants/Colors';
import useTranslation from 'Hooks/useTranslation';
import useUpdate from '../Hooks/useUpdate';

export default function ModalEdit({
  data = null,
  cancel = () => {},
  accept = () => {},
  allRoles = [],
  setAllRoles = () => {},
  isActive = null,
}) {
  const { t } = useTranslation();
  const { handleClick } = useUpdate({
    data,
    cancel,
    allRoles,
    setAllRoles,
  });

  return (
    <div className="col" style={{ padding: '1rem', gap: '1rem', display: 'grid' }}>
      <DialogTitle
        style={{
          fontWeight: 'bold',
          color: colors.BLACK,
          fontFamily: 'quicksand',
          textAlign: 'center',
        }}
      >
        {isActive ? `${t('Roles.InactiveUserType')}` : `${t('Roles.ActiveUserType')}`}
      </DialogTitle>
      <DialogContent className="col">
        <DialogContentText style={{ fontFamily: 'var(--app-font)', textAlign: 'center' }}>
          {isActive ? `${t('Roles.InactiveDescription')}${t('Roles.Employee')}` : `${t('Roles.ActiveDescription')}`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          style={{ fontFamily: 'quicksand', color: colors.GREEN_LEAF, border: `1px solid ${colors.GREEN_LEAF}` }}
          variant="outlined"
          onClick={cancel}
        >
          {t('Generic.Cancel')}
        </Button>
        <Button
          style={{ fontFamily: 'quicksand', background: colors.GREEN_LEAF }}
          onClick={async () => {
            await handleClick();
            accept();
          }}
          variant="contained"
        >
          {t('Generic.Accept')}
        </Button>
      </DialogActions>
    </div>
  );
}
